import type { GeneratedStory } from 'schemas';
import { GeneratedStoriesResponseSchema } from 'schemas';
import { apiRequest } from '@/api/helpers/apiRequest';
import { handleApiError } from '@/api/helpers/handleApiError';

export const fetchGeneratedStories = async (): Promise<GeneratedStory[]> => {
  try {
    return await apiRequest(
      'GET',
      '/api/generated-stories',
      undefined,
      GeneratedStoriesResponseSchema
    );
  } catch (error) {
    handleApiError(error);
  }
};
